import React from "react";
import { MainArticle, Article } from "components";
import { HomeArticleTitle } from "./HomeArticle.styles.js";

const HomeArticle = () => {
  return (
    <MainArticle>
      <HomeArticleTitle>Crónica para Eva</HomeArticleTitle>
      <Article>
        Témele tú, el del alma pequeña, a la mujer sin pudor. Escóndete debajo
        de las piedras, en el corazón de los matorrales, cuando la veas mientras
        atraviesa el puente de Tirry con los ojos un poco más claros que el
        verde del San Juan. Corre si ves que regala poemas como quien da los
        buenos días, aunque sepa que no son buenos días - que hoy no llega el
        agua, que del pan de la bodega no basta y el vino volvió a subir de
        precio- ,pero no le importa porque hoy en lo que se pintaba los labios
        decidió que regalaría poemas. Apártate del camino cuando venga la mujer
        con aura de ciudad avanza hacia ti.
      </Article>
      <Article>
        Carilda Oliver Labra creció en una Matanzas pequeña burguesa donde el
        bacará no se juntaba con el vidrio, las mujeres perdían sus nombres en
        los recovecos del registro civil. No existían las Isabel Cristinas o las
        Marías o las Lauras, sino la señorita, la divorciada, la viuda. Carilda
        rompe contra estas etiquetas, como mismo, se cortan las que sobresalen
        de los vestidos, porque a nadie debería interesarle ni la talla ni el
        precio.
      </Article>
      <Article>
        Le da voz a las señoritas, a las divorciadas, a las viudas, como mismo
        la poeta fue cada una de ellas; pero, gracias a ese tono intimista en
        que demuestra que carmín adentro todas son el mismo ser sensible y
        doliente, demuestra que en realidad no hay una diferencia entre cada una
        de ellas. Como mismo se nombra uno de sus poemas más famosos, ella
        construye el discurso de Eva.{" "}
      </Article>
      <Article>
        Cuando hablamos de Carilda resulta casi imposible discernir dónde
        comienza la poesía y dónde la mujer, y ahí radica su encanto. No sabemos
        si de tanto escribir del amor, el de los sostenes que vuelan o el de las
        conversaciones intrascendente a media tarde en un café esquinado, ella
        misma se trasformó en ese gran personaje que ronda su poesía erótica, la
        amante de carne y espíritu; o, si por el contrario, siempre fue la
        amante y nada más.{" "}
      </Article>
      <Article>
        Sin embargo, aquellos que la quisieron mucho, concuerdan que su
        popularidad proviene de eso mismo, de lo difícil que resulta separar el
        sujeto lírico de esa mujer con los labios rojos que se paseaba por la
        Calle en Medio. Así lo afirma Arístides Vega Chapú poeta santaclareño,
        que vivió en Matanzas a finales de los ochenta y principio de los
        noventa, lo que le permitió conocer de cerca a la inquilina de Tirry 81.{" "}
      </Article>
      <Article>
        Cuentan que a finales de los 70 al concluir el ostracismo al que gente
        sin fe la condenaron en su primer recital utilizó el mismo vestido que
        en el último quince años atrás. Así lo recuerda Arturo Arango. Carilda
        era mucho Carilda, porque una voz profunda que es como si naciera del
        sistema cavernario debajo de Matanzas, no puedes silenciarla.{" "}
      </Article>
      <Article>
        Además, su obra tenía esa rara condición que gustaba por igual a los
        críticos y a los bodegueros. Es raro que un matancero no conozca por lo
        menos su nombre y el verso de ¡Me desordeno, mi amor, me desordeno!
        Según Maylán Álvarez poeta matancera contemporánea es suficiente para
        que sea recordada en la historia de las Letras hispanoamericanas.
      </Article>
      <Article>
        Quizás Carilda sea una de las mayores exponentes de la matanceridad.
        Esta entendida como esas incoherencias léxicas, geográficas y sociales
        que diferencian al matancero de otro cualquier habitante de ciudad o de
        Isla. Tal vez peque un poco de chovinismo, pero diré que quizás de la
        misma manera que a la ciudad le nació una poeta, la poeta dio a la luz
        una ciudad. Ello queda más que claro en Canto a Matanzas, oda de Carilda
        a la ciudad a veces imaginada e hiperbolizada.{" "}
      </Article>
      <Article>
        Alfredo Zaldívar, poeta y editor, comentó que para él la universalidad
        de Carilda radica en lo tan matancera que fue. A través de los tiempos
        Matanzas siempre ha parido al Poeta que ha necesitado. Cuando
        requeríamos una sensibilidad propia, de esas que la más mínima fealdad
        moral repleta de ronchas el alma, en un parto de agua, en un pacto con
        las aguas, nació Milanés, el amante tímido.{" "}
      </Article>
      <Article>
        Del aire, liviano y juguetón, llegó Plácido, mulato y libre, con sus
        poemas de aquellas pequeñas cosas que nos hacen flotar por encima de la
        cotidianidad. De la tierra, en la que se encaja el asta de las banderas,
        la que si nos caemos nos permite erguirnos y pelear, vino Byrne, con su
        estirpe de patriarca. Desde el fuego, el que como el amor fue el primer
        refugio de los hombres, en el siglo XX, aparece Carilda, rubísima,
        ojiverde y transgresora.
      </Article>
    </MainArticle>
  );
};

export default HomeArticle;
